'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/react-dom/index.js
 ** module id = 257
 ** module chunks = 2
 **/